import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/auth'
import { LoadingState } from '../components/ui'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading, fetchUser, shops } = useAuthStore()
  const location = useLocation()

  useEffect(() => {
    // Only fetch user if not already authenticated and not loading
    if (!isAuthenticated && isLoading) {
      fetchUser()
    }
  }, [isAuthenticated, isLoading, fetchUser])

  if (isLoading) {
    return <LoadingState fullPage />
  }

  if (!isAuthenticated) {
    // Redirect to login, but save the current location so we can redirect back
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (shops.length === 0) {
    return <Navigate to="/onboarding" replace />
  }

  return <>{children}</>
}
